<template>
	<div class="container">
		<div class="tishi">信息提示：</div>
		<div class="alert">设置后可通过安全问题找回密码。</div>
		<el-form ref="form" label-width="100px" class="modify-form">
			<el-form-item label="安全问题">
				<el-select v-model="form.b1">
					<el-option value="1" label="我叫什么名字？"></el-option>
					<el-option value="2" label="你又叫什么名字？"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="问题答案">
				<el-input v-model="form.a"></el-input>
			</el-form-item>
			<div style="text-align:center">
				<el-button type="primary">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {}
		};
	}
};
</script>


<style lang="scss" scoped>
.tishi {
	padding-left: 10px;
	font-size: 18px;
	font-weight: 600;
	margin-top: 20px;
	color: #000;
}
.alert {
	margin-top: 20px;
	padding: 10px 20px;
	background: #eee;
}
.modify-form {
	margin-top: 20px;
}
</style>

